import React, { useContext, useEffect, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import { useState } from "react";
import axios from "axios";
import { useMediaQuery } from "@mui/material";
import Select from "react-select";
import { AppContext } from "../context/AppContext";
import axiosInstance from "../utils/AxiosInstance";

const AddReportModal = ({
  isOpen,
  onClose,
  fetchData,
  isEditMode,
  editData,
  setEditData,
  setEditMode,
  workspaces,
  fetchWorkspaces,
  workSpaceReports,
  fetchWorkspacesReports,
  pipelines,
  fetchPipelines,
}) => {
  const {
    register,
    handleSubmit,
    watch,
    control,
    setValue,
    formState: { errors },
  } = useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const {
    setLoader,
    setToast,
    setApplicationOption,
    ApplicationOption,
    // selectapplication,
    // setSelectapplication,
  } = useContext(AppContext);
  const [selectedWorkspace, setSelectedWorkspace] = useState(
    isEditMode && editData?.workspace ? editData.workspace : null
  );
  const [selectedReport, setSelectedReport] = useState(
    isEditMode && editData?.report ? editData.report : null
  );
  const [selectapplication, setSelectapplication] = useState(
    isEditMode && editData?.report ? editData.report : null
  );
  const [selectedPipeline, setSelectedPipeline] = useState(
    isEditMode && editData?.pipeline ? editData.pipeline : null
  );
  const [initialTitle, setInitialTitle] = useState("");

  const inputRefs = useRef({});
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const allFields = watch();
  const [rlsType, setRlsType] = useState("report");
  const fetchApplications = async () => {
    try {
      setLoader(true);
      const response = await axiosInstance.get("/getexternalReports");
      if (response.data) {
        setApplicationOption(
          response.data?.data?.map((item) => ({
            value: item.ID,
            label: item.NAME,
          }))
        );
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error("Error fetching roles:", error);
    }
  };
  // useEffect(()=>{
  //     fetchApplications()
  // },[])
  // useEffect(() => {
  //   console.log("selectedPipeline", selectedPipeline);
  //   if (isOpen) {
  //   fetchApplications()
  //     fetchPipelines();

  //     if (isEditMode && editData) {
  //       setValue("title", editData.title);
  //       setInitialTitle(editData.title);
  //       setSelectedWorkspace(editData.workspace);
  //       setSelectedPipeline(editData.pipeline);
  //       setSelectedReport(editData.report);

  //       if (editData.workspace) {
  //         fetchWorkspacesReports(editData.workspace.id);
  //       }
  //     }
  //   }
  // }, [isOpen, isEditMode, editData, setValue]);
  useEffect(() => {
    if (isOpen) {
      fetchPipelines();
      fetchApplications();

      if (isEditMode && editData) {
        // --- EDIT MODE ---
        setValue("title", editData.title);
        setValue("titleApplication", editData.title);
        setInitialTitle(editData.title);
        // setInitialTitle(editData.title);

        if (editData.pipeline?.id === null) {
          setRlsType("application");
          const appValue = editData?.report
            ? { value: editData.report.id, label: editData.report.name }
            : null;

          setSelectapplication(appValue);
          // setSelectapplication(editData?.report)
          setValue("ReportTitle", editData.report);
        } else {
          setRlsType("report");
          setSelectedPipeline(editData.pipeline);
          setSelectedWorkspace(editData.workspace);
          setSelectedReport(editData.report);

          setValue("pipeline", editData.pipeline);
          setValue("workspace", editData.workspace);
          setValue("report", editData.report);

          // if (editData.pipeline?.id) fetchWorkspaces(editData.pipeline.id);
          // if (editData.workspace?.id)
          //   fetchWorkspacesReports(editData.workspace.id);
          if (editData.workspace) {
            fetchWorkspacesReports(editData.workspace.id);
          }

        }
      }
      // else {
      //   reset();
      //   setRlsType("report");
      //   setSelectedPipeline(null);
      //   setSelectedWorkspace(null);
      //   setSelectedReport(null);
      //   setSelectapplication([]);
      // }
    }
  }, [isOpen, isEditMode, editData, setValue]);

  useEffect(() => {
    if (selectedWorkspace?.id) {
      fetchWorkspacesReports(selectedWorkspace.id);
    }
  }, [selectedWorkspace]);

  useEffect(() => {
    if (selectedPipeline?.id) {
      fetchWorkspaces(selectedPipeline?.id);
    }
  }, [selectedPipeline]);

  const isTitleChanged = () => {
    return allFields.title && allFields.title.trim() !== initialTitle;
  };

  const areSelectionsValid = () => {
    if (!selectedWorkspace || !selectedReport) return false;

    // If workspace changed, report must also be changed
    if (selectedWorkspace.id !== editData?.workspace?.id) {
      return selectedReport.id !== editData?.report?.id;
    }

    // If workspace is same, report can be different
    return true;
  };

  // const isFormComplete = isEditMode
  //   ? isTitleChanged() || areSelectionsValid()
  //   : ["title", "pipeline", "workspace", "report"].every(
  //       (field) =>
  //         allFields[field] &&
  //         (typeof allFields[field] === "string"
  //           ? allFields[field].trim() !== ""
  //           : true)
  //     );
  // const isFormComplete = isEditMode
  //   ? isTitleChanged() || areSelectionsValid()
  //   : rlsType === "report"
  //   ? ["title", "pipeline", "workspace", "report"].every(
  //       (field) =>
  //         allFields[field] &&
  //         (typeof allFields[field] === "string"
  //           ? allFields[field].trim() !== ""
  //           : true)
  //     )
  //   : rlsType === "application"
  //   ? selectapplication && selectapplication.value && selectapplication.label
  //   : false;
  const isFormComplete = isEditMode
    ? // In edit mode, check if title changed or selections are valid
    (rlsType === "report" ? isTitleChanged() || areSelectionsValid() : selectapplication && selectapplication.value && selectapplication.label)
    : rlsType === "report"
      ? // New report: all report fields must be filled
      ["title", "pipeline", "workspace", "report"].every(
        (field) =>
          allFields[field] &&
          (typeof allFields[field] === "string" ? allFields[field].trim() !== "" : true)
      )
      : rlsType === "application"
        ? // New application: titleApplication and selectapplication must be filled
        allFields.titleApplication &&
        allFields.titleApplication.trim() !== "" &&
        selectapplication &&
        selectapplication.value &&
        selectapplication.label
        : false;

  console.log("isFormComplete:", isFormComplete, "selectapplication:", selectapplication);

  const onSubmit = async (data) => {
    if (!isEditMode) {
      setIsSubmitting(true);
      setLoader(true);
      try {
        let payload;

        if (rlsType === "application") {
          payload = {
            title: data.titleApplication,
            pipeline: { id: null, name: null },
            workspace: { id: null, name: null },
            report: selectapplication
              ? { id: selectapplication.value, name: selectapplication.label }
              : {},
            type: "Web Application",

            // reportTitle: data.ReportTitle?.map((app) => ({
            //   id: app.value,
            //   name: app.label,
            // })) || [],
          };
        } else {
          payload = {
            // title: data.title,
            ...data,
            pipeline: selectedPipeline,
            workspace: selectedWorkspace,
            report: selectedReport,
          };
        }
        const response = await axiosInstance.post("/add-bookmarks", payload);

        if (response.status) {
          fetchData();
          setLoader(false);
          setToast({
            show: true,
            type: "success",
            message: "Report added Successfully",
          });
          onClose();
        }
      } catch (error) {
        if (error.response && error.response.status === 409) {
          fetchData();
          setLoader(false);
          setToast({
            show: true,
            type: "error",
            message: "A Report with the same name already exists",
          });
          onClose();
        } else if (error.response && error.response.status === 410) {
          setEditMode(true);
          setEditData(error?.response?.data?.data);
          setLoader(false);
          setToast({
            show: true,
            type: "error",
            message: "Report already exists. You can edit it here.",
          });
        }
        console.error("Error adding report:", error);
      } finally {
        setIsSubmitting(false);
      }
    } else {
      setIsSubmitting(true);
      setLoader(true);
      try {
        let payload;

        if (rlsType === "application") {
          payload = {
            title: data.titleApplication,
            report: selectapplication
              ? { id: selectapplication.value, name: selectapplication.label }
              : {},
            pipeline: { id: null, name: null },
            workspace: { id: null, name: null },
            type: "Web Application",
          };
        } else {
          payload = {
            title: data.title,
            pipeline: selectedPipeline,
            workspace: selectedWorkspace,
            report: selectedReport,
          };
        }

        const response = await axiosInstance.put(
          `/update-ReportCard/${editData._id}`,
          payload
        );

        if (response.status) {
          fetchData();
          setLoader(false);
          setToast({
            show: true,
            type: "success",
            message: "Report updated Successfully",
          });
          onClose();
        }
      } catch (error) {
        setLoader(false);
        setToast({
          show: true,
          type: "error",
          message: "Something went wrong",
        });
        console.error("Error updating report:", error);
      } finally {
        setIsSubmitting(false);
      }
    }
  };


  if (!isOpen) return null;

useEffect(() => {
  const fetchTitle = async () => {
    try {
      if (
        rlsType === "report" &&
        selectedPipeline &&
        selectedWorkspace &&
        selectedReport &&
        !isEditMode &&
        !initialTitle
      ) {
        const response = await axiosInstance.post("/getBookmarkTitle", {
          pipeline: selectedPipeline,
          workspace: selectedWorkspace,
          report: selectedReport,
        });

        if (response.status === 200 && response.data?.title) {
          setValue("title", response.data.title);
          setValue("titleApplication", response.data.title);
          setInitialTitle(response.data.title);
          setEditMode(true);

            if (response.data?.data) {
              setEditMode(true);
              setEditData(response.data.data);
            }

          setToast({
            show: true,
            type: "error",
            message: "Report already exists. You can edit it here.",
          });
        }
      }

      // === Case 2: Application type ===
      else if (
        rlsType === "application" &&
        selectapplication &&
        selectapplication.value &&
        !isEditMode &&
        !initialTitle
      ) {
        const response = await axiosInstance.post(
          "/getBookmarkTitleForApplication",
          {
            report: {
              id: selectapplication.value,
              name: selectapplication.label,
            },
          }
        );

        if (response.status === 200 && response.data?.title) {
          setValue("title", response.data.title);
          setValue("titleApplication", response.data.title);
          setInitialTitle(response.data.title);
          setEditMode(true);

          if (response.data?.data) setEditData(response.data.data);

          setToast({
            show: true,
            type: "error",
            message:
              "Application report already exists. You can edit it here.",
          });
        }
      } else {
        console.log("No title fetch triggered — waiting for selections...");
      }
    }catch (error) {
      if (error.response?.status === 404) {
        // No existing record — do nothing
      } else {
        console.error("Error fetching title:", error);
      }
    }
  }
    fetchTitle();
  }, [
    selectedPipeline,
    selectedWorkspace,
    selectedReport,
    isEditMode,
    initialTitle,
    setValue,
  ]);
  useEffect(() => {
    console.log(isEditMode, selectapplication, "isEditMode");
  }, [isEditMode]);
  useEffect(() => {
    console.log(rlsType, "rlsType");
  }, [rlsType]);
  const handleTypeChange = (e) => {
    const isApplication = e.target.checked;
    setRlsType(isApplication ? "application" : "report");

    // Clear the title field whenever the type changes
    setValue("title", "");
  };


 async function checkReportExists() {
  if (!isEditMode) {
    setIsSubmitting(true);
    setLoader(true);

    try {
      let payload;

      if (rlsType === "application") {
        payload = {
          report: selectapplication
            ? { id: selectapplication.value, name: selectapplication.label }
            : {},
          type: "Web Application",
        };
      } else {
        payload = {
          report: selectedReport,
        };
      }

      const response = await axiosInstance.post("/checkReportExists", payload);

      console.log("Response:", response.data);

      setLoader(false);
      setIsSubmitting(false);
    } 
    catch (error) {
      if (error.response && error.response.status === 410) {
        setEditMode(true);
        setEditData(error.response.data.data);
        setToast({
          show: true,
          type: "error",
          message: "Report already exists. You can edit it here.",
        });
      } else {
        console.error("Error adding report:", error);
        setToast({
          show: true,
          type: "error",
          message: "Failed to check report existence.",
        });
      }
    } 
    finally {
      setIsSubmitting(false);
      setLoader(false);
    }
  }
}

  useEffect(() => {

    if(selectedReport || selectapplication)
checkReportExists()


  }, [selectedReport,selectapplication])
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-md w-full max-w-md shadow-lg relative">
        <button
          onClick={onClose}
          className="absolute top-1 right-3 text-gray-500 hover:text-gray-800 text-xl font-bold"
        >
          &times;
        </button>

        <h2 className="text-2xl font-semibold mb-4">
          {isEditMode ? "Update Report" : "Add Report"}
        </h2>
        {!isEditMode && (
          <div className="md:col-span-2 flex items-center gap-4 mt-4 mb-4">
            <label className="text-sm font-medium">Type:</label>

            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="rlsType"
                value="report"
                checked={rlsType === "report"}
                onChange={(e) => {
                  setRlsType(e.target.value);
                  // setValue("title", "");
                  // setValue("ReportTitle", "");
                }}
              />
              <span>Report</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="rlsType"
                value="application"
                checked={rlsType === "application"}
                onChange={(e) => {
                  setRlsType(e.target.value);
                  // setValue("title", "");
                  // setValue("ReportTitle", "");
                }}
              />
              <span>Application</span>
            </label>

          </div>
        )}

        {/* {!isEditMode && (
          <div className="md:col-span-2 flex items-center gap-4 mt-4 mb-4">
            <label className="text-sm font-medium">Type:</label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={rlsType === "application"}
                onChange={(e) =>{
                  setRlsType(e.target.checked ? "application" : "report")
                  // setValue("title",'')
                  // setValue("ReportTitle",'')
                }
                }
              />
              <span>Application</span>
            </label>
          </div>
        )} */}
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          {
            rlsType === 'report' ?
              <div>
                <label
                  htmlFor="title"
                  className="block text-sm font-medium text-gray-700"
                >
                  Report Title*
                </label>
                <input
                  type="text"
                  id="title"
                  className="w-full px-4 py-2 mt-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  {...register("title", { required: "Title is required" })}
                />
                {errors.title && (
                  <span className="text-red-500 text-sm">
                    {errors.title.message}
                  </span>
                )}
              </div>
              :
              <>
                <div>
                  <label
                    htmlFor="titleApplication"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Application Title*
                  </label>
                  <input
                    type="text"
                    id="titleApplication"
                    className="w-full px-4 py-2 mt-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    {...register("titleApplication", { required: "Title is required" })}
                  />
                  {errors.title && (
                    <span className="text-red-500 text-sm">
                      {errors.titleApplication.message}
                    </span>
                  )}
                </div>

              </>
          }

          {rlsType === "report" ? (
            <>
              <div>
                <label
                  htmlFor="pipeline"
                  className="block text-sm font-medium text-gray-700"
                >
                  Pipeline{!isEditMode && "*"}
                </label>
                <Controller
                  name="pipeline"
                  control={control}
                  rules={{ required: rlsType === "report" && !isEditMode }}
                  render={({ field }) => (
                    <Select
                      id="pipeline"
                      value={
                        pipelines.find(
                          (c) => c.value === selectedPipeline?.id
                        ) ||
                        (isEditMode && editData?.pipeline
                          ? pipelines.find(
                            (c) => c.value === editData.pipeline.id
                          ) || null
                          : null)
                      }
                      onChange={(value) => {
                        const selectedData = value
                          ? { id: value.value, name: value.label }
                          : null;
                        setSelectedPipeline(selectedData);
                        setSelectedWorkspace(null);
                        field.onChange(selectedData);
                      }}
                      options={pipelines}
                      className="mt-1"
                      isClearable={true}
                      isDisabled={isEditMode}
                      menuPortalTarget={document.body}
                      menuPlacement="auto"
                      menuShouldScrollIntoView={false}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        menuList: (provided) => ({
                          ...provided,
                          maxHeight: isSmallScreen ? "80px" : "150px",
                          overflowY: "auto",
                          fontSize: isSmallScreen ? "10px" : "14px",
                        }),
                      }}
                    />
                  )}
                />
                {errors.pipeline && (
                  <span className="text-red-500 text-sm">
                    {errors.pipeline.message}
                  </span>
                )}
              </div>

              <div>
                <label
                  htmlFor="workspace"
                  className="block text-sm font-medium text-gray-700"
                >
                  Workspace{!isEditMode && "*"}
                </label>
                <Controller
                  name="workspace"
                  control={control}
                  rules={{ required: rlsType === "report" && !isEditMode }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      id="workspace"
                      value={
                        workspaces.find(
                          (c) => c.value === selectedWorkspace?.id
                        ) ||
                        (isEditMode && editData?.workspace
                          ? workspaces.find(
                            (c) => c.value === editData.workspace.id
                          ) || null
                          : null)
                      }
                      onChange={(value) => {
                        const selectedData = value
                          ? { id: value.value, name: value.label }
                          : null;
                        setSelectedWorkspace(selectedData);
                        setSelectedReport(null); // Reset report when workspace changes
                        field.onChange(selectedData);
                      }}
                      options={workspaces}
                      className="mt-1"
                      isClearable={true}
                      isDisabled={
                        (!selectedPipeline && !editData?.selectedPipeline) ||
                        isEditMode
                      }
                      menuPortalTarget={document.body}
                      menuPlacement="auto"
                      menuShouldScrollIntoView={false}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        menuList: (provided) => ({
                          ...provided,
                          maxHeight: isSmallScreen ? "80px" : "150px",
                          overflowY: "auto",
                          fontSize: isSmallScreen ? "10px" : "14px",
                        }),
                      }}
                    />
                  )}
                />
                {errors.workspace && (
                  <span className="text-red-500 text-sm">
                    {errors.workspace.message}
                  </span>
                )}
              </div>

              <div>
                <label
                  htmlFor="report"
                  className="block text-sm font-medium text-gray-700"
                >
                  Report{!isEditMode && "*"}
                </label>
                <Controller
                  name="report"
                  control={control}
                  rules={{ required: rlsType === "report" && !isEditMode }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      id="reports"
                      value={
                        workSpaceReports.find(
                          (c) => c.value === selectedReport?.id
                        ) ||
                        (isEditMode &&
                          editData?.report &&
                          (!selectedWorkspace ||
                            selectedWorkspace.id === editData.workspace.id)
                          ? workSpaceReports.find(
                            (c) => c.value === editData.report.id
                          ) || null
                          : null)
                      }
                      onChange={(value) => {
                        const selectedData = value
                          ? { id: value.value, name: value.label }
                          : null;
                        setSelectedReport(selectedData);
                        field.onChange(selectedData);
                      }}
                      options={workSpaceReports}
                      className="mt-1"
                      isClearable={true}
                      isDisabled={
                        (!selectedWorkspace && !editData?.workspace) ||
                        isEditMode
                      }
                      // menuPortalTarget={document.body}
                      menuPlacement="auto"
                      menuShouldScrollIntoView={false}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        menuList: (provided) => ({
                          ...provided,
                          maxHeight: isSmallScreen ? "80px" : "150px",
                          overflowY: "auto",
                          fontSize: isSmallScreen ? "10px" : "14px",
                        }),
                      }}
                    />
                  )}
                />
                {errors.report && (
                  <span className="text-red-500 text-sm">
                    {errors.report.message}
                  </span>
                )}
              </div>
            </>
          ) : (
            <div>
              <label
                htmlFor="Report Title"
                className="block text-sm font-medium text-gray-700"
              >
                Application{!isEditMode && "*"}
              </label>
              <Controller
                name="ReportTitle"
                control={control}
                rules={{ required: rlsType === "application" && !isEditMode }}
                render={({ field }) => (
                  <Select
                    id="ReportTitle"
                    value={selectapplication}
                    onChange={(selected) => {
                      setSelectapplication(selected);
                      field.onChange(selected);
                    }}
                    isDisabled={isEditMode}
                    options={ApplicationOption}
                    className="mt-1"
                    isClearable={true}
                    // isMulti
                    menuPortalTarget={document.body}
                    menuPlacement="auto"
                    menuShouldScrollIntoView={false}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menuList: (provided) => ({
                        ...provided,
                        maxHeight: isSmallScreen ? "80px" : "150px",
                        overflowY: "auto",
                        fontSize: isSmallScreen ? "10px" : "14px",
                      }),
                    }}
                    required
                  />
                )}
              />
              {errors.ReportTitle && (
                <span className="text-red-500 text-sm">
                  {errors.ReportTitle.message}
                </span>
              )}
            </div>
          )}

          <div className="flex justify-end mt-6">
            <button
              type="submit"
              disabled={
                isSubmitting ||
                !isFormComplete ||
                // editData?.title == watch("title")
                (rlsType === "report" && editData?.title === watch("title")) ||
                (rlsType === "application" && editData?.title === watch("titleApplication"))
              }
              className={`px-6 py-2 text-white bg-[#e31c23] transition-colors duration-200 active:bg-[#F87171] ${isSubmitting ||
                  !isFormComplete ||
                  (rlsType === "report" && editData?.title == watch("title")) || (rlsType === "application" && editData?.title == watch("titleApplication"))
                  ? "opacity-50 cursor-not-allowed"
                  : "transition-colors duration-300 hover:bg-[#b91c1c]"
                } rounded-md focus:outline-none`}
            >
              {isSubmitting
                ? "Submitting..."
                : isEditMode
                  ? "Update Report"
                  : "Add Report"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddReportModal;
